import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';


const template = styled.div`
  ${({ displayState }) => css`
    border: ${displayState?.border ?? ''};
    border-left: ${displayState?.borderLeft ?? ''};
    border-radius: ${displayState?.borderRadius ?? ''};
    padding: ${displayState?.padding ?? ''};
    background: ${displayState?.background ?? ''};
    height: ${displayState?.height ?? ''};
    width: ${displayState?.width ?? ''};

    ${displayState?.hoverColor && css`
      &:hover {
        border-color: ${displayState?.hoverColor};
      }
    `}

    ${displayState?.hoverBackground && css`
      &:hover {
        background: ${displayState?.hoverBackground};
      }
    `}

    ${displayState?.cursor && css`
      &:hover {
        cursor: ${displayState?.cursor};
      }
    `}
  `}
`

export default Wrapper(template)